import React from 'react';

const base = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const PhoneIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M15 10 20 5" />
    <path d="M16 3h5v5" />
    <path d="M18.5 14.5c.4 1.7.6 3.4.6 5a1.5 1.5 0 0 1-1.5 1.5C9.5 21 3 14.5 3 6.4A1.5 1.5 0 0 1 4.5 5c1.6 0 3.3.2 5 .6a1.5 1.5 0 0 1 1 2.1L9 10.5a11.4 11.4 0 0 0 4.5 4.5l2.8-1.5a1.5 1.5 0 0 1 2.1 1z" />
  </svg>
);

export const UsersIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export const MessageIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

export const TableIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="M3 10h18" />
    <path d="M9 10v10" />
  </svg>
);

export const RefreshIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M3 12a9 9 0 0 1 15.3-6.4L21 8" />
    <path d="M21 3v5h-5" />
    <path d="M21 12a9 9 0 0 1-15.3 6.4L3 16" />
    <path d="M3 21v-5h5" />
  </svg>
);

export const TrashIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
);

export const ChevronLeftIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

export const ChevronRightIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M9 18l6-6-6-6" />
  </svg>
);

export const ChevronsLeftIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M11 17l-5-5 5-5" />
    <path d="M18 17l-5-5 5-5" />
  </svg>
);

export const ChevronsRightIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M13 17l5-5-5-5" />
    <path d="M6 17l5-5-5-5" />
  </svg>
);

export const MenuIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 7h16" />
    <path d="M4 12h16" />
    <path d="M4 17h16" />
  </svg>
);

export const CloseIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M18 6 6 18" />
    <path d="M6 6l12 12" />
  </svg>
);

export const ShieldIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

export const LogoutIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
);

export const SunIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="M4.93 4.93l1.41 1.41" />
    <path d="M17.66 17.66l1.41 1.41" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="M4.93 19.07l1.41-1.41" />
    <path d="M17.66 6.34l1.41-1.41" />
  </svg>
);

export const MoonIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
  </svg>
);

export const DialpadIcon = (props) => (
  <svg {...base} fill="currentColor" stroke="none" {...props}>
    <circle cx="6" cy="6" r="1.9" />
    <circle cx="12" cy="6" r="1.9" />
    <circle cx="18" cy="6" r="1.9" />
    <circle cx="6" cy="12" r="1.9" />
    <circle cx="12" cy="12" r="1.9" />
    <circle cx="18" cy="12" r="1.9" />
    <circle cx="6" cy="18" r="1.9" />
    <circle cx="12" cy="18" r="1.9" />
    <circle cx="18" cy="18" r="1.9" />
  </svg>
);

export const PlayIcon = (props) => (
  <svg {...base} fill="currentColor" stroke="none" {...props}>
    <path d="M8 5v14l11-7z" />
  </svg>
);

export const DownloadIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 3v12" />
    <path d="M7 10l5 5 5-5" />
    <path d="M4 19h16" />
  </svg>
);

export const CopyIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="9" y="9" width="12" height="12" rx="2" />
    <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
  </svg>
);

export const TrendIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M3 17l6-6 4 4 8-8" />
    <path d="M17 7h4v4" />
  </svg>
);

export const LayoutDashboardIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="3" width="7" height="9" rx="1" />
    <rect x="14" y="3" width="7" height="5" rx="1" />
    <rect x="14" y="12" width="7" height="9" rx="1" />
    <rect x="3" y="16" width="7" height="5" rx="1" />
  </svg>
);

export const KeyIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="8" cy="15" r="4" />
    <path d="M10.5 12.5 20 3" />
    <path d="M16 7l3 3" />
    <path d="M13 10l3 3" />
  </svg>
);

export const HashIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M5 9h14" />
    <path d="M5 15h14" />
    <path d="M10 4L8 20" />
    <path d="M16 4l-2 16" />
  </svg>
);

export const SearchIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="11" cy="11" r="7" />
    <path d="M21 21l-4.3-4.3" />
  </svg>
);

export const ChevronDownIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const CalendarIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M3 10h18" />
  </svg>
);

export const CalendarClockIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect x="3" y="4" width="18" height="17" rx="2" />
    <path d="M3 10h18" />
    <circle cx="15.5" cy="15.5" r="3.5" />
    <path d="M15.5 14v1.5l1 1" />
  </svg>
);

export const FlagIcon = (props) => (
  <svg {...base} fill="currentColor" stroke="none" {...props}>
    <path d="M6 21V4a1 1 0 0 1 1-1h10.4a1 1 0 0 1 .8 1.6l-2.7 3.6 2.7 3.6a1 1 0 0 1-.8 1.6H7v7.6a1 1 0 1 1-1-1z" />
  </svg>
);

export const CartIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="9" cy="21" r="1" />
    <circle cx="19" cy="21" r="1" />
    <path d="M2.5 3h2l2.4 12.2a2 2 0 0 0 2 1.6h8.6a2 2 0 0 0 2-1.6L21 8H6" />
  </svg>
);

export const CheckIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const UserIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21a8 8 0 0 1 16 0" />
  </svg>
);

export const CameraIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

export const SaveIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
    <path d="M17 21v-8H7v8" />
    <path d="M7 3v5h8" />
  </svg>
);

export const BackspaceIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M9 5h11a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9l-6-7z" />
    <path d="M13 10l4 4" />
    <path d="M17 10l-4 4" />
  </svg>
);

export const PinIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 2a5 5 0 0 0-5 5c0 3 2 5.2 3 7.3L12 22l2-7.7c1-2.1 3-4.3 3-7.3a5 5 0 0 0-5-5z" />
    <circle cx="12" cy="7" r="1.6" fill="currentColor" stroke="none" />
  </svg>
);

export const SendIcon = (props) => (
  <svg {...base} fill="currentColor" stroke="none" {...props}>
    <path d="M3 11.5 21 3l-6.5 18-3.2-7.3L3 11.5z" />
  </svg>
);

export const PaperclipIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M21.4 11.5 12.5 20.4a5 5 0 0 1-7.1-7.1l9-9a3.5 3.5 0 0 1 5 5l-9 9a2 2 0 0 1-2.8-2.8l8.2-8.2" />
  </svg>
);

export const FileIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z" />
    <path d="M14 3v5a1 1 0 0 0 1 1h5" />
  </svg>
);

export const EmojiIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <circle cx="9" cy="10" r="1" fill="currentColor" stroke="none" />
    <circle cx="15" cy="10" r="1" fill="currentColor" stroke="none" />
    <path d="M8 14c1 1.5 2.5 2.3 4 2.3s3-.8 4-2.3" />
  </svg>
);

export const BookmarkIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M6 3h12a1 1 0 0 1 1 1v17l-7-4-7 4V4a1 1 0 0 1 1-1z" />
  </svg>
);

// Sticky note with a folded corner — the chat composer's "internal note" toggle.
export const NoteIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 4h16v10l-6 6H4z" />
    <path d="M14 20v-6h6" />
    <path d="M8 9h8M8 12.5h4" />
  </svg>
);

export const ImageIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="8.5" cy="8.5" r="1.5" />
    <path d="M21 15l-5-5-11 11" />
  </svg>
);

export const MicIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0" />
    <path d="M12 18v3" />
  </svg>
);

export const VideoIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="2" y="5" width="14" height="14" rx="2" />
    <path d="M16 10l6-3v10l-6-3z" />
  </svg>
);

export const WhatsAppIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
    <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
  </svg>
);

export const GlobeIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="10" />
    <path d="M2 12h20" />
    <path d="M12 2a15 15 0 0 1 0 20 15 15 0 0 1 0-20z" />
  </svg>
);

export const MailIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M2 6l10 7 10-7" />
  </svg>
);

export const ReplyIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M9 17l-5-5 5-5" />
    <path d="M4 12h10a5 5 0 0 1 5 5v2" />
  </svg>
);

export const ForwardIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M15 17l5-5-5-5" />
    <path d="M20 12H10a5 5 0 0 0-5 5v2" />
  </svg>
);

export const StarIcon = ({ filled, ...props }) => (
  <svg {...base} {...(filled ? { fill: 'currentColor' } : {})} {...props}>
    <path d="M12 2.5l2.9 6.4 6.9.7-5.2 4.7 1.5 6.9-6.1-3.6-6.1 3.6 1.5-6.9-5.2-4.7 6.9-.7z" />
  </svg>
);

export const InboxIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 12h4l2 3h4l2-3h4" />
    <path d="M4 12 5.5 5a2 2 0 0 1 2-1.5h9a2 2 0 0 1 2 1.5L20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" />
  </svg>
);

export const LinkIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M10 14a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.5 1.5" />
    <path d="M14 10a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.5-1.5" />
  </svg>
);

export const ListIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="4" cy="6" r="1" fill="currentColor" stroke="none" />
    <circle cx="4" cy="12" r="1" fill="currentColor" stroke="none" />
    <circle cx="4" cy="18" r="1" fill="currentColor" stroke="none" />
    <path d="M9 6h11" />
    <path d="M9 12h11" />
    <path d="M9 18h11" />
  </svg>
);

export const RefundIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
    <path d="M3 3v5h5" />
    <path d="M12 8v8" />
    <path d="M9.5 10.5h4a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 0 0 3h4" />
  </svg>
);

export const TruckIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M1 5h13v11H1z" />
    <path d="M14 9h4l4 4v3h-8" />
    <circle cx="6" cy="18.5" r="2" />
    <circle cx="17.5" cy="18.5" r="2" />
  </svg>
);

export const WalletIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M3 7a2 2 0 0 1 2-2h13a1 1 0 0 1 1 1v3" />
    <path d="M3 7v10a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1H6a1 1 0 0 1 0-2h15" />
    <circle cx="17" cy="13" r="1.5" fill="currentColor" stroke="none" />
  </svg>
);

export const LayoutGridIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="3" width="7" height="7" rx="1" />
    <rect x="14" y="3" width="7" height="7" rx="1" />
    <rect x="3" y="14" width="7" height="7" rx="1" />
    <rect x="14" y="14" width="7" height="7" rx="1" />
  </svg>
);

// A parcel with a return arrow - RTO stock coming back into the warehouse.
export const PackageReturnIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M21 8.5V17a1 1 0 0 1-.55.9l-7.5 3.75a1 1 0 0 1-.9 0l-7.5-3.75A1 1 0 0 1 4 17V8.5" />
    <path d="M3 7.5 12 3l9 4.5-9 4.5z" />
    <path d="M12 12v9.5" />
    <path d="M9 17H6.5" />
    <path d="m8 15.5-1.5 1.5L8 18.5" />
  </svg>
);

// A parcel with a crack down its front - a product that arrived damaged.
export const DamagedPackageIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M21 8.5V17a1 1 0 0 1-.55.9l-7.5 3.75a1 1 0 0 1-.9 0l-7.5-3.75A1 1 0 0 1 4 17V8.5" />
    <path d="M3 7.5 12 3l9 4.5-9 4.5z" />
    <path d="m15 11.5 1.5 2.5-2 1.5 2 2.5" />
  </svg>
);

export const MoreIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="5" cy="12" r="1.2" fill="currentColor" />
    <circle cx="12" cy="12" r="1.2" fill="currentColor" />
    <circle cx="19" cy="12" r="1.2" fill="currentColor" />
  </svg>
);

export const InfoIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5" />
    <path d="M12 8h.01" />
  </svg>
);

export const ArrowLeftIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M19 12H5" />
    <path d="M11 6l-6 6 6 6" />
  </svg>
);

export const SettingsIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
  </svg>
);

export const ZapIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M13 2 4 14h7l-1 8 9-12h-7z" />
  </svg>
);

export const CheckCircleIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="m8.5 12 2.5 2.5 4.5-5" />
  </svg>
);

export const ChevronUpIcon = (props) => (
  <svg {...base} {...props}>
    <path d="m6 15 6-6 6 6" />
  </svg>
);
